import React from 'react';
import ReactDOM from 'react-dom';
import { inWindow } from 'api';
import { useAppSelector } from '@web-common/state/createStore';
const TinymceTooltip = () => {
    const { top, left, title } = useAppSelector(state => state.mailReducer.editorTooltip);
    const child = (React.createElement("div", { className: "toolbar-tooltip-wrap" },
        React.createElement("div", { className: "toolbar-tooltip", style: {
                top,
                left,
            } }, title)));
    if (!inWindow())
        return React.createElement(React.Fragment, null);
    return ReactDOM.createPortal(child, document.body);
};
export default TinymceTooltip;
